var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestiondot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 85,
    viewBox: "0 0 1440 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.081 84.5718H1440V75.7518H237.901V0.23999H153.481V75.84H0V84.66H162.338V9.05999H229.118",
    fill: "#FF8A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestiondot);
export default __webpack_public_path__ + "static/media/questiondot.8023770c68202c2dfd946960ab7459fb.svg";
export { ForwardRef as ReactComponent };